<!--Options-->
<div class="ItemBorder">
	<!--Instructions-->
	<div>
		<h4 style="text-align: center">Instructions</h4>
		<ul>
			<li>Pick File Options</li>
			<li>Pick a File to Import</li>
			<li>Select what each column represents</li>
			<li>Press Import to load the information</li>
			<li>Required Columns are Student/Staff ID and Email</li>
			<li>Note: Student ID is used for both Student Portal and Parent Portal</li>
			<li>Note: Email is Guardian's email for Parent app, Student's email for Student app and Staff's email for staff app</li>
		</ul>
	</div>

	<!--Select File-->
	<div class="OptionGrid2Col">
		<label>App:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="AppTypeID" [(ngModel)]="AppTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAppType" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Format:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="FormatOptionID"
			[(ngModel)]="FormatOptionID"
			(ngModelChange)="onFormatOptionIDChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFormatOption" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Skip First Line:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SkipFirstLineID"
			[(ngModel)]="SkipFirstLineID"
			(ngModelChange)="onSkipFirstLineIDChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSkipFirstLineID" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>
	</div>
	<div class="OptionGrid2Col">
		<input id="ImportInput" name="ImportInput" type="file" style="display: none" (change)="onFileToImportChange($event)" />
		<label class="InfoText">{{ FileName }}</label>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSelectFile()">Select a File</button>
	</div>
</div>

<!--Select Columns-->
<div *ngIf="FileData == null" class="ItemBorder TopMargin" style="text-align: center">
	<label>- Select a File -</label>
</div>

<div *ngIf="FileData != null" class="ItemBorder TopMargin">
	<h4 style="text-align: center">Preview:</h4>
	<p-table
		#mydt
		[value]="lstTable"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<tr>
				<th *ngFor="let col of lstCols; let i = index">
					<select class="form-control" [(ngModel)]="OptArray[i]">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstRequiredColumns" [ngValue]="o.ID">{{ o.Desc }}</option>
					</select>
				</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-TableVal>
			<tr>
				<td *ngFor="let o of lstCols; let i = index" style="font-weight: bold">
					{{ TableVal[i] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="ReadyToImport == false" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onCancel()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>
